module.exports = __webpack_public_path__ + "static/img/zhong1.5a317a2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/zhong1.jpeg
// module id = fqX9
// module chunks = 0